module.exports = __webpack_public_path__ + "img/icon-blog.077876d8.svg";